module.exports = __webpack_public_path__ + "static/media/logo.fc0aff5f.png";